<div class="toast-container">
  <div (click)="clearToast()" class="{{ cssClass() }}" [ngClass]="{ 'toast-active': alert }">
    <div>
      {{ alert?.message }}
      <a *ngFor="let link of alert?.links" routerLink="{{ link?.link }}">{{ link?.title }}</a>
    </div>
  </div>
</div>
